import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

import { Tags } from 'root/admin/components';

import store from 'root/admin/store';
import { Loader, TabMenu, MenuItem } from '@smartplatform/ui';

const menuItems = [
	{
		label: 'Видео',
		id: 'media',
	},
	{
		label: 'Категории',
		id: 'tags',
	},
];
@observer
export default class Media extends React.Component {
	@observable tab;

	switchTab = record => {
		this.tab = record.id;
		this.props.history.push(`/admin/media/${record.id}`);
		store.ui.setPage(record.id);
	};

	render() {
		const rootPath = '/admin/media';
		if (store.route.path === rootPath) {
			return <Redirect to={`${rootPath}/media`} />;
		}

		return (
			<div>
				<TabMenu>
					{menuItems.map(record => (
						<MenuItem
							key={`category-${record.id}`}
							label={record.label}
							onClick={() => this.switchTab(record)}
							active={store.ui.page === record.id}
						/>
					))}
				</TabMenu>

				<Route exact path={`${rootPath}/media`} component={() => <List rootPath={rootPath} tabName="media" />} />
				<Route exact path={`${rootPath}/media/:id`} component={() => <Edit rootPath={rootPath} tabName="media" />} />
				<Route path={`${rootPath}/tags`} component={() => <Tags model="media" />} />
			</div>
		);
	}
}
